import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STISCUpdateReverseScan = _resolveComponent("STISCUpdateReverseScan")!
  const _component_STISCUpdateV2 = _resolveComponent("STISCUpdateV2")!

  return (_ctx.isReverseScanSTISC)
    ? (_openBlock(), _createBlock(_component_STISCUpdateReverseScan, { key: 0 }))
    : (_openBlock(), _createBlock(_component_STISCUpdateV2, { key: 1 }))
}